<div class="tw-flex tw-items-center">
  <h1 class="matp-page-title">アラート状況</h1>
</div>
<app-alert-summary
  [disabled]="isMapMoving"
  [deviceHistoryFormGroup]="deviceHistoryFormGroup"
  [shipmentHistoryFormGroup]="shipmentHistoryFormGroup"
  [latestDevicesSummary]="latestDevicesSummary"
  [tenantCreatedAt]="tenantCreatedAt"
  (historyFiltered)="findAlertList()"
  (sensingTypeChanged)="onSensingTypeChanged($event)"
  (displayPageChanged)="onDisplayPageChanged($event)"
></app-alert-summary>
@if (selectedDisplayPage === "device") {
  <div class="tw-flex tw-gap-x-16 tw-h-[calc(100%_-_240px)]">
    <div
      class="tw-flex tw-flex-col tw-gap-y-2 tw-min-w-[750px] tw-overflow-y-auto tw-relative"
    >
      <app-alert-detail
        [alertList]="alertDetailList"
        [unit]="selectedSensingUnit"
        [selectedSensingType]="selectedSensingType"
        [mapBounds]="mapBounds"
        [selectedMarker]="selectedMarker"
        [loading]="alertLoading || alertProcessing"
        (alertDetailChanged)="onAlertDetailChanged($event)"
        (markerChanged)="onMarkerChanged($event)"
        class="tw-min-w-[700px]"
      ></app-alert-detail>
    </div>
    <div class="tw-w-full tw-h-full tw-min-w-[600px]">
      <app-alert-map
        class="tw-h-full"
        [alertList]="alertLocationList"
        [selectedAlertDetail]="selectedAlertDetail"
        [selectedMarker]="selectedMarker"
        [sensingType]="selectedSensingType"
        [displayPageChanged]="selectedDisplayPage"
        (mapMoveStart)="onMapMoveStart()"
        (mapMoveEnd)="onMapMoveEnd($event)"
        (markerChanged)="onMarkerChanged($event)"
      ></app-alert-map>
    </div>
  </div>
} @else {
  <div class="tw-w-full tw-h-[calc(100%_-_150px)]">
    <div class="tw-flex !tw-pt-4 tw-gap-x-16 tw-h-full">
      <div
        class="tw-flex tw-flex-col tw-gap-y-2 tw-min-w-[750px] tw-overflow-y-auto tw-relative"
      >
        <app-shipment-sensor-alert-detail
          [alertList]="shipmentSensorAlertList"
          [historyFormGroup]="shipmentHistoryFormGroup"
          [selectedMarker]="selectedSensorAlertMarker"
          [mapBounds]="mapBounds"
          [loading]="
            shipmentSensorAlertLoading || shipmentSensorAlertProcessing
          "
          (alertDetailChanged)="onShipmentSensorAlertDetailChanged($event)"
          class="tw-min-w-[700px]"
        ></app-shipment-sensor-alert-detail>
      </div>
      <div class="tw-w-full tw-h-full tw-min-w-[600px]">
        <app-shipment-alert-map
          class="tw-h-full"
          [alertList]="shipmentSensorAlertLocationList"
          [selectedAlertDetail]="selectedSensorAlertDetail"
          [selectedMarker]="selectedSensorAlertMarker"
          [displayPageChanged]="selectedDisplayPage"
          (mapMoveStart)="onMapMoveStart()"
          (mapMoveEnd)="onMapMoveEnd($event)"
          (markerChanged)="onShipmentMarkerChanged($event)"
        ></app-shipment-alert-map>
      </div>
    </div>
  </div>
}
